import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { timeout } from 'rxjs/operators';
import { CommonFunctions } from 'src/app/Utilities/CommonFunctions';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionPlanService {
  constructor(private http: HttpClient) {}

  private getHeaders() {
    const TOKEN = CommonFunctions.getToken();
    return new HttpHeaders({
      Authorization: 'Bearer ' + TOKEN,
      'Content-Type': 'application/json'
    });
  }

  listPlans() {
    const url = environment.API_URL_BUSINESS_ADMIN + '/api/anonymous/subscriptions';
    return this.http.get(url).pipe(timeout(60000));
  }

  addPlan(plan: any) {
    const url = environment.API_URL_BUSINESS_ADMIN + '/api/subscription';
    return this.http.post(url, { data: plan }, { headers: this.getHeaders() }).pipe(timeout(60000));
  }

  editPlan(plan: any, id: any) {
    const url = environment.API_URL_BUSINESS_ADMIN + '/api/subscription/' + id;
    return this.http.put(url, { data: plan }, { headers: this.getHeaders() }).pipe(timeout(60000));
  }

  removePlan(id: any) {
    const url = environment.API_URL_BUSINESS_ADMIN + '/api/subscription/' + id;
    return this.http.delete(url, { headers: this.getHeaders() }).pipe(timeout(60000));
  }
}
